import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import SidebarEspacios from '../../components/espacios/SidebarEspacios';
import './EspaciosGlobal.css';

const ReservasEspacios = () => {
  const [reservas, setReservas] = useState([]);
  const [areas, setAreas] = useState([]);
  const [espacios, setEspacios] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [saving, setSaving] = useState(false);
  
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const [formData, setFormData] = useState({
    responsable: '',
    rut: '',
    area_id: '',
    espacio_id: '',
    fecha: '',
    hora_inicio: '',
    hora_fin: '',
    motivo: ''
  });

  const user = JSON.parse(localStorage.getItem('user_espacios') || '{}');
  const initial = user.nombre ? user.nombre.charAt(0).toUpperCase() : 'A';

  const isLocal = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
  const apiBase = isLocal ? `http://${window.location.hostname}:3010` : `${window.location.protocol}//${window.location.hostname}`;

  useEffect(() => { 
    if (!localStorage.getItem('user_espacios')) {
      navigate('/espacios/login');
      return;
    }
    fetchInitialData();
    
    // Si viene de reserva directa desde el horario
    const qDate = queryParams.get('date');
    const qTime = queryParams.get('time');
    if (qDate && qTime) {
      setFormData(prev => ({ 
        ...prev, 
        fecha: qDate, 
        hora_inicio: qTime,
        hora_fin: `${(parseInt(qTime.split(':')[0]) + 1).toString().padStart(2, '0')}:00` 
      }));
      setShowModal(true);
    }
  }, [location.search]);

  const fetchInitialData = async () => {
    try {
      const [resResp, areasResp, spacesResp] = await Promise.all([
        fetch(`${apiBase}/api/espacios/reservas`, { credentials: 'include' }),
        fetch(`${apiBase}/api/espacios/areas`, { credentials: 'include' }),
        fetch(`${apiBase}/api/espacios/espacios`, { credentials: 'include' })
      ]);
      const resData = await resResp.json();
      const areasData = await areasResp.json();
      const spacesData = await spacesResp.json();
      setReservas(Array.isArray(resData) ? resData : []);
      setAreas(Array.isArray(areasData) ? areasData : []);
      setEspacios(Array.isArray(spacesData) ? spacesData : []);
    } catch (err) {
      console.error('Error fetching data:', err);
    } finally {
      setLoading(false);
    }
  };

  const [step, setStep] = useState(1);
  const [weekOffset, setWeekOffset] = useState(0);

  const handleSave = async (e) => {
    if (e) e.preventDefault();
    if (!formData.hora_inicio || !formData.hora_fin) {
      alert('Por favor seleccione un horario en la agenda.');
      return;
    }
    setSaving(true);
    try {
      const resp = await fetch(`${apiBase}/api/espacios/reservas`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
        credentials: 'include'
      });
      if (resp.ok) {
        setShowModal(false);
        setStep(1);
        setFormData({ responsable: '', rut: '', area_id: '', espacio_id: '', fecha: '', hora_inicio: '', hora_fin: '', motivo: '' });
        fetchInitialData();
      } else {
        alert('Error al guardar la reserva');
      }
    } catch (err) {
      console.error('Error saving reserva:', err);
    } finally {
      setSaving(false);
    }
  };

  const updateLlaveStatus = async (id, newStatus) => {
    try {
      const resp = await fetch(`${apiBase}/api/espacios/reservas/${id}/llave`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ estado_llave: newStatus }),
        credentials: 'include'
      });
      if (resp.ok) fetchInitialData();
    } catch (err) {
      console.error('Error updating llave:', err);
    }
  };

  const handleFinalizar = async (res) => {
    // Validación de Seguridad: Llave obligatoria
    if (res.requiere_llave === 1 && res.estado_llave !== 'Devuelta') {
      alert('⚠️ BLOQUEO DE SEGURIDAD: No se puede finalizar la reserva hasta que la llave física sea devuelta.');
      return;
    }

    if (!window.confirm('¿Desea dar por finalizada esta reserva y cerrar el expediente?')) return;

    try {
      const resp = await fetch(`${apiBase}/api/espacios/reservas/${res.id}/estado`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ estado: 'Finalizada' }),
        credentials: 'include'
      });
      if (resp.ok) fetchInitialData();
    } catch (err) {
      console.error('Error finalizando reserva:', err);
    }
  };

  const isStep1Complete = () => {
    return formData.responsable && formData.rut && formData.area_id && formData.espacio_id && formData.motivo;
  };

  if (loading) return (
    <div className="App-layout-espacios">
      <SidebarEspacios />
      <main className="App-main-espacios">
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
          <div className="spinner"></div>
        </div>
      </main>
    </div>
  );

  return (
    <div className="App-layout-espacios">
      <SidebarEspacios />
      
      <main className="App-main-espacios">
        <header className="view-page-header">
          <div className="view-title-block">
            <h2>Gestión de Reservas</h2>
            <p>Control de expedientes y autorizaciones de uso</p>
          </div>
          <div className="header-actions">
            <button className="btn-high-end btn-high-end-primary" onClick={() => { setStep(1); setShowModal(true); }}>
              <i className="fa-solid fa-plus-circle"></i> Crear Solicitud
            </button>
            <div className="user-pill-dark">
              <div className="avatar">{initial}</div>
              <span>{user.nombre || 'Administrador'}</span>
            </div>
          </div>
        </header>

        <div className="calendar-glass-card" style={{ padding: 0, overflow: 'hidden' }}>
          <div className="calendar-table-wrapper" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
            <table className="table-premium">
              <thead>
                <tr>
                  <th style={{ width: '100px' }}>Folio</th>
                  <th style={{ textAlign: 'left' }}>Recinto Asignado</th>
                  <th style={{ textAlign: 'left' }}>Responsable Técnico</th>
                  <th>Programación</th>
                  <th>Estado</th>
                  <th>Llave</th>
                  <th style={{ textAlign: 'right', paddingRight: '24px' }}>Acciones</th>
                </tr>
              </thead>
              <tbody>
                {reservas.map(res => (
                  <tr key={res.id}>
                    <td style={{ fontWeight: '800', color: 'var(--esp-primary)' }}>#{res.id.substring(0,6)}</td>
                    <td style={{ textAlign: 'left', fontWeight: '700' }}>
                      {res.espacio_nombre}
                      {res.requiere_llave === 1 && <i className="fa-solid fa-key" style={{ marginLeft: '8px', color: 'var(--p-amber)', fontSize: '10px' }} title="Requiere Llave"></i>}
                    </td>
                    <td style={{ textAlign: 'left' }}>
                      <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <span style={{ fontWeight: '600' }}>{res.responsable}</span>
                        <small style={{ color: 'var(--esp-text-muted)', fontSize: '11px' }}>RUT: {res.rut}</small>
                      </div>
                    </td>
                    <td>
                      <div style={{ fontSize: '12px' }}>
                        <i className="fa-regular fa-calendar" style={{ color: 'var(--esp-primary)', marginRight: '6px' }}></i>
                        {new Date(res.fecha).toLocaleDateString('es-CL', { timeZone: 'UTC' })}
                        <br />
                        <i className="fa-regular fa-clock" style={{ color: 'var(--esp-primary)', marginRight: '6px', marginTop: '4px' }}></i>
                        {res.hora_inicio.substring(0,5)} - {res.hora_fin.substring(0,5)}
                      </div>
                    </td>
                    <td>
                      <span className={`badge-executive ${res.estado === 'Finalizada' ? 'badge-slate' : res.estado === 'Confirmada' ? 'badge-emerald' : 'badge-amber'}`}>
                        {res.estado === 'Finalizada' ? 'Finalizada' : res.estado === 'Confirmada' ? 'Vigente' : 'Pendiente'}
                      </span>
                    </td>
                    <td>
                      {res.requiere_llave === 1 ? (
                        <span className={`badge-executive ${res.estado_llave === 'Entregada' ? 'badge-amber' : res.estado_llave === 'Devuelta' ? 'badge-emerald' : 'badge-slate'}`} style={{ fontSize: '10px' }}>
                          {res.estado_llave || 'Pendiente'}
                        </span>
                      ) : (
                        <span style={{ opacity: 0.3, fontSize: '10px' }}>N/A</span>
                      )}
                    </td>
                    <td style={{ textAlign: 'right', paddingRight: '24px' }}>
                      <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
                        {res.requiere_llave === 1 && res.estado_llave !== 'Devuelta' && (
                          <button 
                            className="btn-high-end" 
                            style={{ background: 'var(--esp-surface-light)', color: 'var(--p-amber)', padding: '6px' }}
                            onClick={() => updateLlaveStatus(res.id, res.estado_llave === 'Entregada' ? 'Devuelta' : 'Entregada')}
                            title={res.estado_llave === 'Entregada' ? 'Marcar como Devuelta' : 'Marcar como Entregada'}
                          >
                            <i className={`fa-solid ${res.estado_llave === 'Entregada' ? 'fa-arrow-rotate-left' : 'fa-key'}`}></i>
                          </button>
                        )}
                        {res.estado === 'Confirmada' && (
                          <button 
                            className="btn-high-end" 
                            style={{ background: 'var(--esp-primary)', color: 'white', padding: '6px 12px', fontSize: '11px', fontWeight: '800' }}
                            onClick={() => handleFinalizar(res)}
                          >
                            Finalizar
                          </button>
                        )}
                        <button className="btn-high-end" style={{ background: 'var(--esp-surface-light)', color: 'white', padding: '6px 12px', fontSize: '12px' }}>
                          Expediente
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {showModal && (
          <div className="modal-overlay" onClick={() => setShowModal(false)} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.8)', backdropFilter: 'blur(10px)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
            <div className="calendar-glass-card" style={{ maxWidth: step === 2 ? '860px' : '640px', width: '95%', padding: '40px', transition: 'max-width 0.3s ease' }} onClick={e => e.stopPropagation()}>
              
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '32px' }}>
                <div>
                  <h3 style={{ fontSize: '24px', fontWeight: '800' }}>Nueva Solicitud de Uso</h3>
                  <p style={{ fontSize: '14px', color: 'var(--esp-text-muted)' }}>{step === 1 ? 'Paso 1: Información Administrativa' : 'Paso 2: Selección de Horario'}</p>
                </div>
                <div style={{ display: 'flex', gap: '8px' }}>
                  <div style={{ width: '32px', height: '32px', borderRadius: '50%', background: step === 1 ? 'var(--esp-primary)' : 'var(--esp-primary-soft)', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: '800', fontSize: '14px' }}>1</div>
                  <div style={{ width: '32px', height: '32px', borderRadius: '50%', background: step === 2 ? 'var(--esp-primary)' : 'var(--esp-primary-soft)', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: '800', fontSize: '14px' }}>2</div>
                </div>
              </div>

              {step === 1 ? (
                <form style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
                  <div className="input-group" style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                    <label style={{ fontSize: '11px', fontWeight: '800', color: 'var(--esp-text-muted)', textTransform: 'uppercase' }}>Nombre Responsable</label>
                    <input type="text" value={formData.responsable} onChange={e => setFormData({...formData, responsable: e.target.value})} placeholder="Nombre completo" required style={{ border: '1px solid var(--esp-border)', borderRadius: '10px', padding: '12px', background: 'var(--esp-surface-light)', color: 'white', outline: 'none' }} />
                  </div>
                  <div className="input-group" style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                    <label style={{ fontSize: '11px', fontWeight: '800', color: 'var(--esp-text-muted)', textTransform: 'uppercase' }}>RUT Responsable</label>
                    <input type="text" value={formData.rut} onChange={e => setFormData({...formData, rut: e.target.value})} placeholder="12.345.678-k" required style={{ border: '1px solid var(--esp-border)', borderRadius: '10px', padding: '12px', background: 'var(--esp-surface-light)', color: 'white', outline: 'none' }} />
                  </div>
                  
                  <div className="input-group" style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                    <label style={{ fontSize: '11px', fontWeight: '800', color: 'var(--esp-text-muted)', textTransform: 'uppercase' }}>Área</label>
                    <select value={formData.area_id} onChange={e => setFormData({...formData, area_id: e.target.value, espacio_id: ''})} required style={{ border: '1px solid var(--esp-border)', borderRadius: '10px', padding: '12px', background: 'var(--esp-surface-light)', color: 'white', outline: 'none' }}>
                      <option value="">Seleccionar Área...</option>
                      {areas.map(a => <option key={a.id} value={a.id}>{a.nombre}</option>)}
                    </select>
                  </div>

                  <div className="input-group" style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                    <label style={{ fontSize: '11px', fontWeight: '800', color: 'var(--esp-text-muted)', textTransform: 'uppercase' }}>Espacio / Recinto</label>
                    <select value={formData.espacio_id} onChange={e => setFormData({...formData, espacio_id: e.target.value})} required style={{ border: '1px solid var(--esp-border)', borderRadius: '10px', padding: '12px', background: 'var(--esp-surface-light)', color: 'white', outline: 'none' }}>
                      <option value="">Seleccionar Espacio...</option>
                      {espacios.filter(e => !formData.area_id || e.area_id === formData.area_id).map(e => (
                        <option key={e.id} value={e.id}>{e.nombre}</option>
                      ))}
                    </select>
                  </div>



                  <div className="input-group" style={{ gridColumn: '1 / -1', display: 'flex', flexDirection: 'column', gap: '8px' }}>
                    <label style={{ fontSize: '11px', fontWeight: '800', color: 'var(--esp-text-muted)', textTransform: 'uppercase' }}>Motivo Institucional</label>
                    <textarea value={formData.motivo} onChange={e => setFormData({...formData, motivo: e.target.value})} placeholder="Detalle el uso del recinto solicitado..." required style={{ minHeight: '80px', borderRadius: '10px', padding: '12px', border: '1px solid var(--esp-border)', background: 'var(--esp-surface-light)', color: 'white', resize: 'vertical', outline: 'none' }}></textarea>
                  </div>

                  <div style={{ display: 'flex', gap: '16px', marginTop: '12px', gridColumn: '1 / -1' }}>
                    <button type="button" className="btn-high-end" style={{ flex: 1, background: 'var(--esp-surface-light)', color: 'white', justifyContent: 'center' }} onClick={() => setShowModal(false)}>Cancelar</button>
                    <button type="button" className="btn-high-end btn-high-end-primary" style={{ flex: 2, justifyContent: 'center' }} disabled={!isStep1Complete()} onClick={() => setStep(2)}>
                      Siguiente: Selección Horario <i className="fa-solid fa-arrow-right" style={{ marginLeft: '8px' }}></i>
                    </button>
                  </div>
                </form>
              ) : (() => {
                const today = new Date();
                const curDay = today.getDay();
                const dToMon = curDay === 0 ? 6 : curDay - 1;
                const wkMon = new Date(today);
                wkMon.setDate(today.getDate() - dToMon + (weekOffset * 7));
                const schSlots = ['08:00','09:00','10:00','11:00','12:00','13:00','14:00','15:00','16:00','17:00','18:00','19:00','20:00','21:00','22:00'];
                const schDays = ['Lun','Mar','Mié','Jue','Vie','Sáb','Dom'];
                const wkDates = Array.from({ length: 7 }, (_, i) => {
                  const d = new Date(wkMon);
                  d.setDate(wkMon.getDate() + i);
                  return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`;
                });
                const selDateStr = formData.fecha;

                return (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                      <label style={{ fontSize: '11px', fontWeight: '800', color: 'var(--esp-text-muted)', textTransform: 'uppercase', margin: 0 }}>Seleccione fecha y horario</label>
                      <div style={{ display: 'flex', gap: '6px' }}>
                        <button type="button" className="btn-high-end" style={{ background: 'var(--esp-surface-light)', color: 'white', padding: '4px 8px', fontSize: '10px' }} onClick={() => setWeekOffset(prev => prev - 1)}><i className="fa-solid fa-chevron-left"></i></button>
                        <button type="button" className="btn-high-end" style={{ background: 'var(--esp-surface-light)', color: 'white', padding: '4px 10px', fontSize: '10px' }} onClick={() => setWeekOffset(0)}>Hoy</button>
                        <button type="button" className="btn-high-end" style={{ background: 'var(--esp-surface-light)', color: 'white', padding: '4px 8px', fontSize: '10px' }} onClick={() => setWeekOffset(prev => prev + 1)}><i className="fa-solid fa-chevron-right"></i></button>
                      </div>
                    </div>
                    <div style={{ display: 'flex', gap: '12px', fontSize: '10px' }}>
                      <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}><div style={{ width: '8px', height: '8px', background: 'var(--esp-surface-light)', borderRadius: '2px' }}></div> Libre</span>
                      <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}><div style={{ width: '8px', height: '8px', background: 'rgba(255,255,255,0.08)', borderRadius: '2px', border: '1px solid rgba(255,255,255,0.2)' }}></div> Ocupado</span>
                      <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}><div style={{ width: '8px', height: '8px', background: 'var(--esp-primary)', borderRadius: '2px' }}></div> Selección</span>
                    </div>
                  </div>

                  {(formData.fecha || formData.hora_inicio) && (
                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: '10px 16px', borderRadius: '10px', background: 'var(--esp-primary-soft)', border: '1px solid rgba(16,185,129,0.2)' }}>
                      <i className="fa-regular fa-calendar" style={{ color: 'var(--esp-primary)', fontSize: '14px' }}></i>
                      <span style={{ fontSize: '13px', fontWeight: '700' }}>
                        {formData.fecha ? new Date(formData.fecha + 'T00:00:00').toLocaleDateString('es-CL', { weekday: 'long', day: 'numeric', month: 'long' }) : 'Haga clic en un día'}
                        {formData.hora_inicio && <> • {formData.hora_inicio}{formData.hora_fin ? ` — ${formData.hora_fin}` : ' → hora de fin'}</>}
                      </span>
                      <button type="button" onClick={() => setFormData({...formData, fecha: '', hora_inicio: '', hora_fin: ''})} style={{ marginLeft: 'auto', background: 'none', border: 'none', color: 'var(--esp-text-muted)', cursor: 'pointer', fontSize: '11px', transition: 'color 0.2s' }} onMouseEnter={e => e.currentTarget.style.color = 'white'} onMouseLeave={e => e.currentTarget.style.color = 'var(--esp-text-muted)'}>
                        <i className="fa-solid fa-xmark"></i> Limpiar
                      </button>
                    </div>
                  )}

                  <div style={{ overflowX: 'auto', borderRadius: '12px', border: '1px solid var(--esp-border)', background: 'var(--esp-surface)' }}>
                    <table className="table-premium" style={{ fontSize: '11px', minWidth: '580px' }}>
                      <thead>
                        <tr>
                          <th className="hour-cell" style={{ padding: '8px 6px', fontSize: '10px' }}></th>
                          {schDays.map((day, idx) => {
                            const isSel = wkDates[idx] === selDateStr;
                            return (
                              <th key={idx} style={{ padding: '8px 4px', fontSize: '10px', background: isSel ? 'var(--esp-primary-soft)' : '', borderBottom: isSel ? '2px solid var(--esp-primary)' : '' }}>
                                {day}
                                <span style={{ display: 'block', opacity: 0.5, fontSize: '9px', marginTop: '1px' }}>{new Date(wkDates[idx] + 'T00:00:00').getDate()}</span>
                              </th>
                            );
                          })}
                        </tr>
                      </thead>
                      <tbody>
                        {schSlots.map(slot => {
                          const hVal = parseInt(slot);
                          return (
                            <tr key={slot}>
                              <td className="hour-cell" style={{ padding: '6px', fontSize: '10px', fontWeight: '700' }}>{slot}</td>
                              {wkDates.map(date => {
                                const isSelDay = date === selDateStr;
                                const isOcc = reservas.some(r => {
                                  const rD = new Date(r.fecha).toISOString().split('T')[0];
                                  const sH = parseInt(r.hora_inicio); const eH = parseInt(r.hora_fin);
                                  return r.espacio_id === formData.espacio_id && rD === date && hVal >= sH && hVal < eH;
                                });
                                const stVal = parseInt(formData.hora_inicio);
                                const enVal = parseInt(formData.hora_fin);
                                const isStart = isSelDay && formData.hora_inicio === slot;
                                const isRange = isSelDay && stVal && enVal && hVal >= stVal && hVal < enVal;
                                const canClick = !isOcc;

                                return (
                                  <td key={date} onClick={() => {
                                    if (!canClick) return;
                                    // Si es un día diferente, cambiar fecha y resetear horas
                                    if (!isSelDay) {
                                      setFormData({ ...formData, fecha: date, hora_inicio: slot, hora_fin: '' });
                                      return;
                                    }
                                    // Mismo día: lógica de selección de rango
                                    if (!formData.hora_inicio || (formData.hora_inicio && formData.hora_fin)) {
                                      setFormData({ ...formData, hora_inicio: slot, hora_fin: '' });
                                    } else {
                                      const cH = parseInt(slot);
                                      if (cH <= stVal) {
                                        setFormData({ ...formData, hora_inicio: slot, hora_fin: '' });
                                      } else {
                                        const collision = reservas.some(r => {
                                          const rD2 = new Date(r.fecha).toISOString().split('T')[0];
                                          if (r.espacio_id !== formData.espacio_id || rD2 !== formData.fecha) return false;
                                          const rs = parseInt(r.hora_inicio); const re = parseInt(r.hora_fin);
                                          for (let i = stVal; i < cH; i++) { if (i >= rs && i < re) return true; }
                                          return false;
                                        });
                                        if (collision) { alert('⚠️ El rango interfiere con una reserva existente.'); }
                                        else { setFormData({ ...formData, hora_fin: slot }); }
                                      }
                                    }
                                  }} style={{
                                    padding: '6px 4px', textAlign: 'center',
                                    cursor: canClick ? 'pointer' : 'default',
                                    background: isOcc ? 'rgba(255,255,255,0.04)' : (isStart || isRange) ? 'var(--esp-primary-soft)' : isSelDay ? 'rgba(255,255,255,0.02)' : '',
                                    borderLeft: isSelDay ? '1px solid rgba(16,185,129,0.1)' : '',
                                    borderRight: isSelDay ? '1px solid rgba(16,185,129,0.1)' : '',
                                    opacity: isSelDay ? 1 : 0.6,
                                    transition: 'all 0.15s ease'
                                  }}>
                                    {isOcc ? <span style={{ fontSize: '9px', color: 'rgba(255,255,255,0.3)' }}><i className="fa-solid fa-lock" style={{ fontSize: '8px' }}></i></span>
                                     : (isStart || isRange) ? <span style={{ fontSize: '9px', color: 'var(--esp-primary)', fontWeight: '800' }}>●</span>
                                     : null}
                                  </td>
                                );
                              })}
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>

                  <div style={{ display: 'flex', gap: '16px', marginTop: '8px' }}>
                    <button type="button" className="btn-high-end" style={{ flex: 1, background: 'var(--esp-surface-light)', color: 'white', justifyContent: 'center' }} onClick={() => setStep(1)}>
                      <i className="fa-solid fa-arrow-left" style={{ marginRight: '8px' }}></i> Volver
                    </button>
                    <button type="button" className="btn-high-end btn-high-end-primary" style={{ flex: 2, justifyContent: 'center' }} disabled={saving || !formData.fecha || !formData.hora_inicio || !formData.hora_fin} onClick={handleSave}>
                      {saving ? 'Guardando...' : 'Finalizar Solicitud'}
                    </button>
                  </div>
                </div>
                );
              })()}
            </div>
          </div>
        )}
      </main>
    </div>
  );
};

export default ReservasEspacios;
